import { bluePaletteDark, grayPaletteDark, royalBluePaletteDark } from '../../themes/dark-colors';

export const searchFiltersDarkTheme = {
  clearFilter: {
    hover: {
      backgroundColor: royalBluePaletteDark['100'],
    },
    active: {
      backgroundColor: royalBluePaletteDark['200'],
    },
  },
  button: {
    inactive: {
      border: grayPaletteDark[300],
      backgroundColor: grayPaletteDark[100],
      icon: {
        color: grayPaletteDark[500],
      },
      label: {
        color: grayPaletteDark[700],
      },
      active: {
        backgroundColor: royalBluePaletteDark[200],
        borderColor: royalBluePaletteDark[300],
      },
      hover: {
        backgroundColor: royalBluePaletteDark[100],
        borderColor: royalBluePaletteDark[300],
      },
    },
    active: {
      border: bluePaletteDark[500],
      backgroundColor: grayPaletteDark[0],
      hover: {
        backgroundColor: royalBluePaletteDark['100'],
        borderColor: bluePaletteDark['500'],
      },
      active: {
        backgroundColor: royalBluePaletteDark['200'],
        borderColor: bluePaletteDark['500'],
      },
      icon: {
        color: bluePaletteDark[700],
      },
      label: {
        color: bluePaletteDark[700],
      },
    },
  },
  popover: {
    select: {
      backgroundColor: grayPaletteDark[100],
      input: {
        backgroundColor: bluePaletteDark[100],
        hover: {
          notFocus: {
            borderColor: bluePaletteDark[700],
          },
        },
        placeholder: {
          color: royalBluePaletteDark[1000],
        },
        icon: {
          color: royalBluePaletteDark[1000],
        },
      },
    },
    menu: {
      borderTop: grayPaletteDark[300],
      list: {
        backgroundColor: grayPaletteDark[100],
      },
    },
  },
};
